<template>
    <v-dialog v-model="dialog">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Inactive Species Batch Pool</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            Do you want to make the empty species batch pool inactive?
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-alert text type="error" v-if="errorMessage">
                                {{errorMessage}}
                            </v-alert> 
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="primary darken-1" @click="save()" :disabled="saving" :loading="saving" block>Yes</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="warning" @click="dialog = false" block>No</v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import moment from 'moment';

export default {
    data() {
        return {
            dialog: false,
            speciesBatchPoolID: null,
            errorMessage: "",
            saving: false
        };
    },
    methods: {
        async save() {
            this.errorMessage = "";
            this.saving = true;

            try {
      
                var requestData = {
                    SpeciesBatchPoolID: this.speciesBatchPoolID,
                    Inactive: true,
                };
                await venomPoolingAPI.createUpdateSpeciesBatchPool(requestData);

                this.dialog = false;
                this.$emit("updated");
                this.saving = false;
    
                
            }
            catch (e) {
                this.errorMessage = e;
            }
        },
        showDialog(speciesBatchPoolID) {
            this.speciesBatchPoolID = speciesBatchPoolID;

            this.dialog = true;
        }
    }
}
</script>